export default __webpack_public_path__ + "static/media/24.473e9b62.svg";